// 由 EB view/admin/src/router/modules/community.js 自动转换
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router'
import { roterPre } from '@/setting';

const communityRouter: RouteRecordRaw =
{
  path: `${roterPre}/community`,
  name: 'community',
  meta: {
    icon: 'dashboard',
    title: '社区'
  },
  alwaysShow: true,
  component: Layout,
  children: [
    {
      path: 'category',
      name: 'CommunityClassify',
      meta: {
        title: '社区分类',
        noCache: true
      },
      component: () => import('@/views/community/communityClassify/index.vue')
    },
    {
      path: 'topic',
      name: 'CommunityTopic',
      meta: {
        title: '社区话题',
        noCache: true
      },
      component: () => import('@/views/community/communityTopic/index.vue')
    },
    {
      path: 'list',
      name: 'communityList',
      meta: {
        title: '社区内容',
        noCache: true
      },
      component: () => import('@/views/community/communityList/index.vue')
    },
    {
        path: 'reply',
        name: 'communityReply',
        meta: {
          title: '社区评论',
          noCache: true
        },
        component: () => import('@/views/community/communityComment/index.vue')
      }
  ]
}

export default communityRouter;
